import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=8d0ad428&"
import script from "./VerifyCode.vue?vue&type=script&lang=js&"
export * from "./VerifyCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports